export const ICD10WHO2010 = "ICD10-WHO-2010";
export type ICD10WHO2010 = typeof ICD10WHO2010;

export const ICD10WHO2016 = "ICD10-WHO-2016";
export type ICD10WHO2016 = typeof ICD10WHO2016;

export type ICD_VERSION = ICD10WHO2010 | ICD10WHO2016;

export type ICDItem = {
    code: string;

    term?: string;
};
export type favoriteDiagnosis = {
    term: string;

    stack?: string;

    conceptId?: string;
    icd10: ICDItem[];

    version: ICD_VERSION;

    counter?: number;
};

export default favoriteDiagnosis;
